import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=5b68af32&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./transfer.vue?vue&type=style&index=0&id=5b68af32&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68af32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b68af32')) {
      api.createRecord('5b68af32', component.options)
    } else {
      api.reload('5b68af32', component.options)
    }
    module.hot.accept("./transfer.vue?vue&type=template&id=5b68af32&scoped=true", function () {
      api.rerender('5b68af32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wareHouse/transfer.vue"
export default component.exports